/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-14 16:04:30
 */
import {getDevStoreName} from '~/env';

export const handles = [
  'send-personal-letter',
  'send-postcard',
  'send-professional-letter',
  'send-real-penned-letter',
  'send-self-mailer',
  'send-snap-pack-mailer',
] as const;

export type HandleType = typeof handles[number];

/**
 * Get current shopify store name
 */
export const getCurrentShop = (): string => {
  const p = new URLSearchParams(window.location.search);
  return window.location.host.includes(`localhost`)
    ? `${getDevStoreName()}.myshopify.com`
    : p.get('shop') as string;
};

interface CurrentStepInfoResult {
  hmac?: string | null;
  host?: string | null;
  idToken?: string | null;
  locale?: string | null;
  session?: string | null;
  shop?: string | null;
  stepReference?: string | null;
  timestamp?: number | null;
}

const STEP_REFERENCE_LOCAL: Record<HandleType, string> = {
  'send-personal-letter': process.env?.REACT_APP_SHOPIFY_DEV_PERSONAL_LETTER_STEP_REFERENCE ?? '',
  'send-postcard': process.env?.REACT_APP_SHOPIFY_DEV_POST_CARD_STEP_REFERENCE ?? '',
  'send-professional-letter': process.env?.REACT_APP_SHOPIFY_DEV_PROFESSIONAL_LETTER_STEP_REFERENCE ?? '',
  'send-real-penned-letter': process.env?.REACT_APP_SHOPIFY_DEV_REAL_PENNED_LETTER_STEP_REFERENCE ?? '',
  'send-self-mailer': process.env?.REACT_APP_SHOPIFY_DEV_SELF_MAILER_STEP_REFERENCE ?? '',
  'send-snap-pack-mailer': process.env?.REACT_APP_SHOPIFY_DEV_SNAP_PACK_MAILER_STEP_REFERENCE ?? '',
};
export const getCurrentHandle = (): HandleType | null => {
  const pathname = window.location.pathname.replace(/^\/+/, '') as HandleType;
  return handles.includes(pathname) ? pathname : null;
};
export const getCurrentStepInfo = (): CurrentStepInfoResult => {
  if (window.location.host.includes(`localhost`)) {
    // localhost
    const currentHandle = getCurrentHandle();
    return {
      shop: getCurrentShop(),
      stepReference: currentHandle !== null ? STEP_REFERENCE_LOCAL[currentHandle] : null,
    };
  }

  const p = new URLSearchParams(window.location.search);

  return {
    hmac: p.get('hmac'),
    host: p.get('host'),
    idToken: p.get('id_token'),
    locale: p.get('locale'),
    session: p.get('session'),
    shop: p.get('shop'),
    stepReference: p.get('step_reference'),
    timestamp: Number(p.get('timestamp') || 0),
  };
};
